"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _SignupFlows = require("./constants/SignupFlows");

var _AllowedIntents = _interopRequireDefault(require("./constants/AllowedIntents"));

var _IntentsToPath = _interopRequireDefault(require("./constants/IntentsToPath"));

var _UtmsToPath = _interopRequireDefault(require("./constants/UtmsToPath"));

var _HubsToPath = _interopRequireDefault(require("./constants/HubsToPath"));

var _OptsToPath = _interopRequireWildcard(require("./constants/OptsToPath"));

var SIGNUP_ROOT_PATH = '/signup';
var DEFAULT_SIGNUP_PATHNAME = SIGNUP_ROOT_PATH + "/crm";

var buildQueryParams = function buildQueryParams(query) {
  var queries = [];
  var orderedKeys = Object.keys(query).sort();
  orderedKeys.forEach(function (queryKey) {
    if (query.hasOwnProperty(queryKey)) {
      var queryValue = query[queryKey];

      if (queryValue) {
        // should we ever push empty param & values?
        queries.push(encodeURIComponent(queryKey) + "=" + encodeURIComponent(queryValue));
      }
    }
  });
  return queries.length ? "?" + queries.join('&') : '';
};

var getPathFromFlow = function getPathFromFlow(signupFlow) {
  if (_SignupFlows.SignupFlows.hasOwnProperty(signupFlow) && _SignupFlows.SignupFlowToPath.hasOwnProperty(signupFlow)) {
    return _SignupFlows.SignupFlowToPath[signupFlow];
  }

  console.error('Couldn`t find signup flow, defaulting to crm');
  return _SignupFlows.SignupFlowToPath[_SignupFlows.SignupFlows.CRM];
};

var getIntentPathFromIntent = function getIntentPathFromIntent(intentParam) {
  if (_AllowedIntents.default.hasOwnProperty(intentParam) && _IntentsToPath.default.hasOwnProperty(intentParam)) {
    return _IntentsToPath.default[intentParam];
  }

  console.error("Couldn`t find intent for " + intentParam + ", leaving empty");
  return null;
};

var getParamPathFromParam = function getParamPathFromParam(param) {
  var paramToPathMap = Object.assign({}, _OptsToPath.default, {}, _HubsToPath.default, {}, _UtmsToPath.default);
  var path = paramToPathMap[param];

  if (!path) {
    console.error("Couldn`t find mapping for " + param + ", leaving empty");
  }

  return path;
};

var SignupUrlGenerator = /*#__PURE__*/function () {
  function SignupUrlGenerator(signupFlow) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2.default)(this, SignupUrlGenerator);
    this.shouldUpdateOptions = true;
    this.signupFlow = signupFlow;
    this.options = options || {};

    if (!this.options.query) {
      this.options.query = {};
    }

    try {
      var signupRoute = getPathFromFlow(this.signupFlow);
      this.signupPathname = SIGNUP_ROOT_PATH + "/" + signupRoute;
      this.signupQueryParams = this.updateOptions(options);
    } catch (error) {
      this.signupPathname = DEFAULT_SIGNUP_PATHNAME;
      this.signupQueryParams = '';
    }
  }

  (0, _createClass2.default)(SignupUrlGenerator, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var updated = options.query ? buildQueryParams(options.query) : '';
      this.shouldUpdateOptions = false;
      return updated;
    }
  }, {
    key: "getPathname",
    value: function getPathname() {
      return this.signupPathname;
    }
  }, {
    key: "getSearch",
    value: function getSearch() {
      if (this.shouldUpdateOptions) {
        this.signupQueryParams = this.updateOptions(this.options);
        this.shouldUpdateOptions = false;
      }

      return this.signupQueryParams;
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      return "" + this.signupPathname + this.getSearch();
    }
  }, {
    key: "withIntent",
    value: function withIntent(intent) {
      var value = getIntentPathFromIntent(intent);

      if (value) {
        this.options.query.intent = value;
        this.shouldUpdateOptions = true;
      }

      return this;
    }
  }, {
    key: "withParam",
    value: function withParam(param, paramValue) {
      var key = getParamPathFromParam(param);

      if (key) {
        this.options.query[key] = paramValue || _OptsToPath.OptsToValue[param];
        this.shouldUpdateOptions = true;
      }

      return this;
    }
  }, {
    key: "withUtm",
    value: function withUtm(utm, utmValue) {
      return this.withParam(utm, utmValue);
    }
  }, {
    key: "withHubs",
    value: function withHubs(hubs, hubsValue) {
      return this.withParam(hubs, hubsValue);
    }
  }, {
    key: "withOption",
    value: function withOption(option) {
      return this.withParam(option);
    }
  }]);
  return SignupUrlGenerator;
}();

exports.default = SignupUrlGenerator;
module.exports = exports.default;